import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import Countdown from "react-countdown"
import Text from "../shared/Text"

const CountdownStyled = styled.div`
	width: 100%;
	background: ${props => props.theme.colors.white};
	font-family: ${props => props.theme.font.family.heading};
	font-size: ${props => props.theme.font.size.base};
	//font-style: italic;
	position: absolute;
	top: 3.75rem;
	left: 0;
	text-align: center;
	padding: .75rem 0;
	border-bottom: solid 10px ${props => props.theme.colors.secondary};
	strong {
		color: ${props => props.theme.colors.primary};
	}
	@media ${media.sm} {
		top: 5rem;
	}
	@media ${media.md} {
		top: 6.2rem;
		font-size: ${props => props.theme.font.size.md};
	}
	@media ${media.lg} {
		border: none;
		width: auto;
		background: none;
		position: absolute;
		display: inline-block;
		color: ${props => props.theme.colors.white};
		font-family: ${props => props.theme.font.family.heading};
		font-size: ${props => props.theme.font.size.base};
		text-align: center;
		//font-style: italic;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
		strong {
			color: ${props => props.theme.colors.secondary};
			font-size: ${props => props.theme.font.size.md};
		}
	}
	@media (min-width: 1300px) {
		left: 6rem;
	}
	@media (min-width: 1650px) {
		padding: 0;
		margin: 0;
		left: 6rem;
		font-size: ${props => props.theme.font.size.lg};
		strong {
			font-size: ${props => props.theme.font.size.lg};
		}
	}
	${props => props.navActive && css`
		
			display: none!important;
		
	`}
`

const renderer = ({ days, hours, minutes, seconds, completed }) => {
	if (completed) {
		// Render a completed state
		return "";
	} else {
		// Render a countdown
		return(
			<>
				<strong>{days}</strong> DAYS &nbsp; <strong>{hours}</strong> HRS &nbsp; <strong>{minutes}</strong> MINS &nbsp; <strong>{seconds}</strong> SECS
			</>
		)
	}
};

const HeaderCountdown = (props) => {
	const data = useStaticQuery(graphql`
		query {
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

	const { headerCountdown, countdownText, displayCountdown } = data.allWp.edges[0]?.node?.options?.acfOptions
	let date = headerCountdown && headerCountdown.split(',')

	if (date && displayCountdown === "yes") {
		let year = date[0]
		let month = date[1] - 1
		let day = date[2]
		let minutes = date[3]
		let secs = date[4]

		date = new Date(year, month, day, minutes, secs)

		return (
			<CountdownStyled navActive={props.navActive} className="countdown">
				{countdownText &&
					<Text  $countdown $tabletMd className="mb-0">{countdownText}</Text>
					// old props $md $bold $uppercase
				}
				<Countdown
					date={date}
					renderer={renderer}
				/>
			</CountdownStyled>
		)
	} else return ""
}

export default HeaderCountdown